import { Group, Pagination, Skeleton } from '@mantine/core';

interface TablePageSelectorProps {
	pageNumber: number;
	setPageNumber: (pageSize: number) => void;
	totalPages: number;
	isLoading?: boolean;
	margin?: string;
}

export function TablePageSelector({
	pageNumber,
	setPageNumber,
	totalPages,
	isLoading = false,
	margin = '0',
}: TablePageSelectorProps) {
	return (
		<>
			{isLoading ? (
				<>
					<Skeleton visible={isLoading} m={0} w={'100%'}>
						<Group justify="flex-end">
							<Pagination
								mr={margin}
								total={1000}
								value={pageNumber}
								onChange={setPageNumber}
								color="medepos.1"
							/>
						</Group>
					</Skeleton>
				</>
			) : (
				<>
					<Group justify="flex-end">
						<Pagination
							mr={margin}
							total={totalPages}
							value={pageNumber}
							onChange={setPageNumber}
							color="medepos.1"
						/>
					</Group>
				</>
			)}
		</>
	);
}
